import friendlyDate from '@utils/date/friendlyDate'
import userName from '@utils/user/userName'
import useT from '@hooks/useTranslation'
import styles from '@components/chat/styles/ListItemChat.module.css'

const Chat = (props) => {
    const { userId, open, topic, updated, read } = props

    return <article
        onClick={() => open(props)}
        className={read
            ? styles.read
            : styles.unread} >

        <div className={styles.time}>{friendlyDate(updated, useT)}</div>
        <div className={styles.topic}>{topic}</div>
        <div className={styles.note}>{originNote(props, userId, useT)}</div>
    </article>
}

function originNote({ _from: userFrom, _to: userTo }, userId, useT) {
    const { _id: from } = userFrom || {}
    const { _id: to } = userTo || {}

    if (!from) return useT('Wiadomość Systemowa')
    if (!userTo) return useT('użytkownik usunął konto')

    if (userId === from) {
        return `${useT('do')} ${userName(userTo)}`
    }

    if (userId === to) {
        return `${useT('od')} ${userName(userFrom)}`
    }
}

export default Chat